import axios from "./axyos";
import type { CaptchaChallenge } from "../components/SimpleCaptcha/SimpleCaptcha";

const API_CAPTCHA_CHALLENGE = "/captcha/challenge";

export const getCaptchaChallengeApi = async (): Promise<CaptchaChallenge> => {
  const response = await axios.get(API_CAPTCHA_CHALLENGE);
  const data = response?.data?.data || {};
  const code = String(data?.code || "").trim().toUpperCase();
  const proof = String(data?.proof || "").trim();
  const expiresAtRaw = Number(data?.expiresAt);

  if (!code || !proof) {
    throw new Error("CAPTCHA_CHALLENGE_INVALID");
  }

  return {
    code,
    answer: code,
    proof,
    expiresAt: Number.isFinite(expiresAtRaw) ? expiresAtRaw : undefined,
  };
};
